<template>
  <div>
    <v-layout class="mt-2 mb-2">
      <v-flex xs6>
        <BuscaSimplesApi
          label="Buscar"
          :disabled="acao != ''"
          route="gerencial/etapaescolar"
          :fieldSearch="buscarSelect"
          @found="encontrado"
          ref="buscaSimpleApi"
          id="identificadoretapaescolar" >
          <template slot-scope="propSlot" >
            <span>{{ propSlot.item.descricaoetapaescolar }}</span>
          </template>
        </BuscaSimplesApi>
      </v-flex>
      <v-flex xs4 class="ml-3">
        <Select :options="buscaOptions" v-model="buscarSelect" @change="$refs.buscaSimpleApi.busca = ''"/>
      </v-flex>
    </v-layout>
    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>
    <FormBasico
      :acao="acao"
      :id="form.identificadoretapaescolar"
      :novo="novaetapaescolar"
      :editar="editaretapaescolar"
      :excluir="excluiretapaescolar"
      :cancelar="cancelaretapaescolar"
      :submit="onSubmit">
      <v-tabs>
        <v-tabs-slider color="#fff"></v-tabs-slider>
        <v-tab @click="tabelaEtapaEscolar">
          <v-icon left color="#757575">view_list</v-icon>
        </v-tab>
      </v-tabs>
      <v-card>
        <v-card-text >
          <Input type="text" label="Identificador Etapa Escolar" v-model="form.identificadoretapaescolar" disabled />
          <Input type="text" label="Código Etapa Escolar" v-model="form.codigoetapaescolar" disabled />
          <Select :options="modalidadeOptions" v-model="form.identificadormodalidadeetapa" label="Modalidade" :disabled="acao == '' || acao == 'editar'" :v="$v.form.identificadormodalidadeetapa"/>
          <Select :options="nivelOptions" v-model="form.identificadorniveletapa" label="Nível Organização" :disabled="acao == '' || acao == 'editar'" :v="$v.form.identificadorniveletapa"/>
          <Select :options="faseOptions" v-model="form.identificadorfaseetapa" label="Fase" :disabled="acao == '' || acao == 'editar'" :v="$v.form.identificadorfaseetapa"/>
          <Input type="text" max="100" label="Descrição da Etapa Escolar" v-model="form.descricaoetapaescolar" :disabled="acao == ''" :v="$v.form.descricaoetapaescolar" />
          <Input type="text" label="Sigla da Etapa Escolar" v-model="form.siglaetapaescolar" :disabled="acao == ''" :v="$v.form.siglaetapaescolar" />
          <Validator label="A Etapa Escolar está sendo utilizada?" :disabled="acao == ''" :v="$v.form.indicausoetapaescolar">
            <Radio v-model="form.indicausoetapaescolar" :disabled="acao == ''" val="N" label="Não"/>
            <Radio v-model="form.indicausoetapaescolar" :disabled="acao == ''"  val="S" label="Sim"/>
          </Validator>
        </v-card-text>
      </v-card>
    </FormBasico>
    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
  import api from '@/api'
  import BuscaSimplesApi from '@/components/BuscaSimplesApi'
  import SelectBuscaApi from '@/components/SelectBuscaApi'
  import { required, maxLength, minLength, alpha, integer } from 'vuelidate/lib/validators'

  let setFormInicial = () => {
    return {
      identificadoretapaescolar: '',
      identificadormodalidadeetapa: '',
      identificadorniveletapa: '',
      identificadorfaseetapa: '',
      descricaoetapaescolar: '',
      siglaetapaescolar: '',
      indicausoetapaescolar: 'S',
      codigoetapaescolar:'',
    }
  }
  export default {
    name: 'EtapaEscolar',
    components: {
      BuscaSimplesApi
    },
    data () {
      return {
        acao: '',
        form: setFormInicial(),
        submitText: '',
        snackbar: false,
        msgArrayError: [],
        buscarSelect: 'descricaoetapaescolar',
        buscaValidaSelect : false,
        areas: [],
        buscaOptions: [
          { value: 'codigoetapaescolar', text: 'Código' },
          { value: 'identificadoretapaescolar', text: 'Identificador' },
          { value: 'descricaoetapaescolar', text: 'Descrição' },
          { value: 'siglaetapaescolar', text: 'Sigla' }
        ],
        modalidadeOptions: [],
        nivelOptions: [],
        faseOptions: [],
        formUltimo: {}
      }
    },
    validations: {
      form: {
        descricaoetapaescolar: { required,  maxLength: maxLength(100), minLength: minLength(4) },
        siglaetapaescolar: { required,  maxLength: maxLength(2), minLength: minLength(2) },
        identificadormodalidadeetapa: {required},
        identificadorniveletapa: {required},
        identificadorfaseetapa: {required}
      }
    },
    created: function() {
      //this.carregaModalidade();
    },
    watch:{
      'form.identificadormodalidadeetapa'(newVal){
        if(this.acao){
          this.nivelOptions = []
          this.faseOptions = []
          this.form.identificadorniveletapa = ''
          this.form.identificadorfaseetapa = ''
          if(newVal != 0)
            this.carregaNivel()
        }

      },
      'form.identificadorniveletapa'(newVal) {
        if(this.acao){
          this.faseOptions = []
          this.form.identificadorfaseetapa = ''
          if(newVal != 0)
            this.carregaFase()
        }
      }

    },
    methods: {
      tabelaEtapaEscolar(){
        this.$root.$router.push({
            name: 'tabelas',
            params: {
              titulo: 'Etapas Escolares / Listar',
              rota_api: 'gerencial/etapaescolar/tabela',
              ordemGrid: false,
              headers: [
                { text: 'Identificador', value: 'identificadoretapaescolar',sortable: false},
                { text: 'Código', value: 'codigoetapaescolar', sortable: false},
                { text: 'Descrição', value: 'descricaoetapaescolar', sortable: false},
                { text: 'Sigla', value: 'siglaetapaescolar', sortable: false},
                { text: 'Modalidade', value: 'descricaomodalidadeetapa', sortable: false},
                { text: 'Nível de Organização', value: 'descricaoniveletapa', sortable: false},
                { text: 'Fase', value: 'descricaofaseetapa', sortable: false}
              ]
            }
        });
      },
      encontrado (dados) {
        this.form = setFormInicial()
        this.form = { ...dados }
        this.formUltimo = { ...dados }
        this.limpaSelect();
        this.carregaModalidade();
        this.$refs.buscaSimpleApi.lista = [];
      },
      novaetapaescolar(){
        this.acao = 'novo'
        this.form = setFormInicial()
        this.$v.$reset();
        this.limpaSelect();
        this.carregaModalidade();
      },
      editaretapaescolar(){
        this.acao = 'editar'

      },
      excluiretapaescolar: async function () {
      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: "Deseja realmente excluir esta etapa escolar?",
        type: 'warning',
        buttons: [
          { text: 'Excluir', color: 'red', response: true },
          { text: 'Cancelar', color: 'grey', response: false }
        ]
      })

      if(confirmar){
        try{
          const { data } = await api.delete(`gerencial/etapaescolar/${this.form.identificadoretapaescolar}`)

          this.acao = '';
          this.submitText = data.message;
          this.snackbar = true;
          this.form = setFormInicial()
          this.msgArrayError = []
        }
        catch (error) {
          const ntfExcluir = await this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage[0],
            type: 'notification'
          })
        }
      }
    },
      cancelaretapaescolar(){
        if(this.acao == 'novo') {
          this.form = setFormInicial()
          this.limpaSelect()
        }
        else {
          this.form = { ...this.formUltimo }
        }
        this.acao = ''
        this.msgArrayError = []

        this.$v.$reset();
      },
      async carregaModalidade(){
        const { data } = await api.get('gerencial/modalidadeetapa')
        this.modalidadeOptions.push({value:'', text: '' })
        for (const key of data.results) {
          this.modalidadeOptions.push({value: key.identificadormodalidadeetapa , text: key.descricaomodalidadeetapa })
        }
        if(!this.acao)
        await this.carregaNivel()
        //console.log(this.modalidadeOptions )
      },
      async carregaNivel(){
        const { data } = await api.get('gerencial/nivelorganizacaoetapa?identificadormodalidadeetapa='+this.form.identificadormodalidadeetapa)
        this.nivelOptions.push({value:'', text: '' })
        for (const key of data.results) {
          this.nivelOptions.push({value: key.identificadorniveletapa , text: key.descricaoniveletapa })
        }
        if(!this.acao)
        await this.carregaFase()
        //console.log(this.modalidadeOptions )
      },
      async carregaFase(){
        const { data } = await api.get('gerencial/faseetapa?identificadormodalidadeetapa='+this.form.identificadormodalidadeetapa+'&identificadorniveletapa='+this.form.identificadorniveletapa)
        this.faseOptions.push({value:'', text: '' })
        for (const key of data.results) {
          this.faseOptions.push({value: key.identificadorfaseetapa , text: key.descricaofaseetapa })
        }
        //console.log(this.modalidadeOptions )
      },
      onSubmit(){
        this.$v.$touch()
        if (this.$v.$invalid) {
          return
        }
        //console.log(this.form)
        api({
          method: (this.acao === 'novo') ? 'post' : 'put',
          url: 'gerencial/etapaescolar' + ((this.acao === 'novo') ? '' : `/${this.form.identificadoretapaescolar}`),
          data: this.form
        }).then((response) => {
          this.acao = '';
          this.submitText = response.data.message;
          this.snackbar = true;
          this.msgArrayError = []
            this.form = { ...response.data.results }
        }).catch((error) => {
          if(error.response.data.status == 'ERROR_BUSINESS_RULE')
            this.msgArrayError = error.response.data.errorMessage
          if(window.scrollY >= 250)
            window.scrollTo({ top: 0, behavior: 'smooth' })
        })
        this.$v.$reset()
      },
      limpaSelect(){
        this.modalidadeOptions = []
        this.nivelOptions = []
        this.faseOptions = []
      }


    },


  }
</script>

<style >

</style>
